import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ReferenceArea } from '../../../reference-areas/models/reference-area';
import { TimetableEntry } from '../../models/timetable-entry';
import { FormGroup, Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { FormValidationService } from '../../../../shared/services/form-validation.service';

@Component({
  selector: 'app-timetable-edit',
  template: require('./timetable-edit.component.html'),
  styles: [require('./timetable-edit.component.sass')]
})
export class TimetableEditComponent implements OnInit {
  
  @ViewChild('timetableEditModal') timetableEditModal: ElementRef;

  timetableEditModalReference: NgbModalRef;

  @Input() referenceAreas: ReferenceArea[];
  @Input() timetable: TimetableEntry[];
  @Input() projectId: number; 
  
  @Output() save = new EventEmitter<TimetableEntry>();

  timetableForm: FormGroup;
  currentTimetableEntryId: number | undefined;

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    public formValidation: FormValidationService

) {
    this.timetableForm = this.fb.group({
      serviceId: ['', Validators.required],
      start: [{
        "hour": new Date().getHours(),
        "minute": new Date().getMinutes()
      }, Validators.required],
      end: [{
        "hour": new Date().getHours(),
        "minute": new Date().getMinutes()
      }, Validators.required],
      startStation: ['', Validators.required],
      endStation: ['', Validators.required]
    })

  }

  ngOnInit(): void {
    
  }

  async showModal(entry?:  TimetableEntry) {

    this.currentTimetableEntryId = undefined;
    if (entry && entry.id) {
      const start = entry.start && entry.start.split(":");
      const end = entry.end && entry.end.split(":");
      this.currentTimetableEntryId = entry.id;
      this.timetableForm.patchValue({
        ...entry,
        start: {
          "hour": parseInt(start && start[0]) || 0,
          "minute": parseInt(start && start[1]) || 0
        },
        end: {
          "hour": parseInt(end && end[0]) || 0,
          "minute": parseInt(end && end[1]) || 0,
        }
      });
    } 
    this.timetableEditModalReference = await this.modalService.open(this.timetableEditModal, { 
      backdrop: 'static',
      size: 'xl'
    })
  }


  onSave = () => {
    if (this.timetableForm.valid) {
      this.save.emit( this.currentTimetableEntryId ? {
        id: this.currentTimetableEntryId,
        ...this.timetableForm.value,
        start: `${this.timetableForm.value.start.hour}:${this.timetableForm.value.start.minute}`,
        end: `${this.timetableForm.value.end.hour}:${this.timetableForm.value.end.minute}`
      }: {
        ...this.timetableForm.value,
        start: `${this.timetableForm.value.start.hour}:${this.timetableForm.value.start.minute}`,
        end: `${this.timetableForm.value.end.hour}:${this.timetableForm.value.end.minute}`
      })
      this.timetableEditModalReference.close();
    }
    else{
        this.formValidation.validateAllFormFields(this.timetableForm);
      }
  }


}
